(() => {
  document.querySelectorAll('[data-g24-search]').forEach((form) => {
    form.addEventListener('submit', () => {
      const query = form.querySelector('[data-g24-query]');
      const dims = [...form.querySelectorAll('[data-g24-dim]')]
        .map((input) => input.value.trim())
        .filter(Boolean);
      if (query && dims.length) {
        query.value = [query.value.trim(), ...dims].filter(Boolean).join(' ');
      }
    });
  });

  document.querySelectorAll('[data-g24-mega]').forEach((menu) => {
    const toggle = menu.querySelector('[data-g24-mega-toggle]');
    const panel = menu.querySelector('[data-g24-mega-panel]');
    if (!toggle || !panel) return;

    const setOpen = (isOpen) => {
      menu.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    };

    toggle.addEventListener('click', () => {
      setOpen(!menu.classList.contains('is-open'));
    });

    menu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
        toggle.focus();
      }
    });

    document.addEventListener('click', (event) => {
      if (!menu.contains(event.target)) setOpen(false);
    });

    panel.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => setOpen(false));
    });
  });

  const toolbars = document.querySelectorAll('[data-catalog-toolbar]');

  toolbars.forEach((toolbar) => {
    const section = toolbar.closest('section');
    const search = toolbar.querySelector('[data-catalog-search]');
    const filter = toolbar.querySelector('[data-catalog-filter]');
    const cards = section ? section.querySelectorAll('[data-product-card]') : [];

    const update = () => {
      const query = (search?.value || '').trim().toLowerCase();
      const category = filter?.value || '';

      cards.forEach((card) => {
        const text = `${card.dataset.title || ''} ${card.dataset.type || ''} ${card.dataset.sku || ''}`.toLowerCase();
        const matchesQuery = !query || text.includes(query);
        const matchesCategory = !category || (card.dataset.type || '').includes(category);
        card.classList.toggle('is-hidden', !(matchesQuery && matchesCategory));
      });
    };

    search?.addEventListener('input', update);
    filter?.addEventListener('change', update);
  });
})();
